/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ListEnrollmentsStatus } from './listEnrollmentsStatus';

export type ListEnrollmentsParams = {
status?: ListEnrollmentsStatus;
statuses?: ('scheduled' | 'active' | 'paused' | 'completed' | 'cancelled' | 'bounced' | 'error')[] | null;
steps?: number[] | null;
outcomes?: string[] | null;
engagement?: string[] | null;
names?: string[] | null;
exclude_names?: string[] | null;
emails?: string[] | null;
exclude_emails?: string[] | null;
stages?: string[] | null;
exclude_stages?: string[] | null;
search?: string | null;
sort_by?: string | null;
sort_order?: string | null;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
per_page?: number;
};
